import { Component, OnInit, OnDestroy, ElementRef, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';
import { UIRoutes } from '../UIRoutes';
import { DatePipe, DOCUMENT } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ColDef, GridOptions } from 'ag-grid-community';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PendingPaymentsComponent, pendingPaymentItems } from '../pending-payments/pending-payments.component';
import { MatPaginator } from '@angular/material/paginator';
import {MatSort, Sort} from '@angular/material/sort';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component'; // Adjust the path as per your project structure
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { merge, Observable, of as observableOf, pipe, Subscription } from 'rxjs';
import {MatTable} from '@angular/material/table';
import { UtilService } from '../service/util.service';

declare var $: any;
@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit, AfterViewInit, OnDestroy {

  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  mobileColumnDefs: ColDef[] = [];
  columnDefsRoleId3: ColDef[] = [];
  mobileColumnDefsRoleId3: ColDef[] = [];
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  cancelBookingResponse: any;
  showConfirmationIndex: number | null = null;

  constructor(private authService: AuthService, private router: Router, private dialog: MatDialog, private utilService: UtilService) {

    this.gridOptions = <GridOptions>{};
  }



  searchText: any;
  rowData = [];
  private allUserTransactions = [];
  dateRangeError = '';
  private pageSubscription?: Subscription;
  private transactionsSubscription?: Subscription;
  private pendingDialog?: MatDialogRef<PendingPaymentsComponent>;
  private pendingPaymentsChecked = false;
  private destroyed = false;
  externalUserContext;
  currentUserContext;
  roleId;
  datePipe: DatePipe = new DatePipe('en-US');
  startDate: any;
  toDate:any
  tenantId: any;
  selectedStartDateStr: any;
  selectedEndDateStr: any;
  private gridApi;
  private gridColumnApi;

  //booking details
  userName: any;
  bookingId: any;
  userEmail: any;
  userPhone: any;
  bookingDateTime: any;
  endDate:any;
  bookingStatus: any;
  totalAmount: any;
  discountType: any;
  discountAmount: any;
  totalPlatformFeeEndUser: any;
  netAmount: any;
  paymentType: any;
  paymentStatus: any;
  transactionId: any;
  paytmTransactionStatus: any;
  notes: any;
  bookedBy: any;
  slotsBooked = [];
  // AddOns bought with the selected booking (shown separately from slots in the Booking Details popup).
  addOnsBooked: any[] = [];
  addOnsTotal = 0;
  bookingInfo: any;
  isMobile: boolean = false;

  displayedColumns = ["bookingId","customer", "date", "amount", "payment", "booking", "phone", "endDate"];
  data = [];
  resultsLength = 100;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = [];
  isLoading = true;
  pageSize = 20;
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild('bookingDetailsModal') bookingDetailsModal: ElementRef<HTMLElement>;
  @ViewChild('transactionPage') transactionPage: ElementRef<HTMLElement>;
  @ViewChild('transactionResults') transactionResults: ElementRef<HTMLElement>;
  private layoutObserver?: ResizeObserver;
  private layoutFrame = 0;
  private readonly scheduleTableLayout = () => {
    cancelAnimationFrame(this.layoutFrame);
    this.layoutFrame = requestAnimationFrame(() => {
      const results = this.transactionResults?.nativeElement;
      if (!results) return;
      const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
      const top = results.getBoundingClientRect().top + window.scrollY;
      results.style.setProperty('--transaction-results-height', `${Math.max(240, viewportHeight - top - 12)}px`);
    });
  };
  //dataSource: MatTableDataSource<Transaction>;

  ngOnInit() {
     this.authService.syncUserContext();
     this.checkIfMobile();
     this.updateDisplayedColumns();
    this.columnDefs = [
      { headerName: 'BOOKING ID', field: 'bookingId' },
      { headerName: 'CUSTOMER', field: 'userName' },
      { headerName: 'DATE', field: 'bookingDateTime', sortable: true, comparator: this.dateComparator, sort: 'asc', cellRenderer: this.customDateRenderer.bind(this) },
      { headerName: 'BOOKING', field: 'bookingStatus'},
      { headerName: 'AMOUNT', field: 'netAmount', valueFormatter: (p) => (p.value == null ? '' : Number(p.value).toFixed(2)) },
      { headerName: 'PAYMENT', field: 'paymentStatus' },
      { headerName: 'PHONE', field: 'userPhone' },
      { headerName: 'END DATE', field: 'endDate'},
      /* { headerName: 'Email', field: 'userEmail'},
        { headerName: 'TR STATUS', field: 'paytmTransactionStatus'},
       { headerName: 'TR TYPE', field: 'paymentType'} */
    ];
    this.columnDefsRoleId3 = [
      { headerName: 'BOOKING ID', field: 'bookingId', minWidth: 120 },
      { headerName: 'DATE', field: 'bookingDateTime', minWidth: 135, sortable: true, comparator: this.dateComparator, sort: 'asc', cellRenderer: this.customDateRenderer.bind(this) },
      { headerName: 'BOOKING', field: 'bookingStatus', minWidth: 155, cellRenderer: (params)=> {
        // Check if config exists and is not null/blank
        const config = params.data.config;
        const isCash = (params.data.paymentType || '').toLowerCase() === 'cash';
        if (config && config.trim()) {
          const durationMinutes = JSON.parse(config).expiryDuration;
          console.log("Duration : ", durationMinutes);
          // Cash "waiting for payment" has no online payment link; only the send-link flow does.
          if (params.value === "WaitingForPayment" && durationMinutes !== 0 && !isCash) {
            return this.createPaymentLink(params.data.bookingId, params.value);
          }
        }
          return `${params.value}`;
      } } ,
      { headerName: 'AMOUNT', field: 'netAmount', minWidth: 105, valueFormatter: (p) => (p.value == null ? '' : Number(p.value).toFixed(2)) },
      { headerName: 'PAYMENT', field: 'paymentStatus', minWidth: 120 },
      { headerName: 'PHONE', field: 'userPhone', minWidth: 120 },
      /* { headerName: 'Email', field: 'userEmail'},
        { headerName: 'TR STATUS', field: 'paytmTransactionStatus'},
       { headerName: 'TR TYPE', field: 'paymentType'} */
    ];
    this.mobileColumnDefs = [
      { headerName: 'BOOKING ID', field: 'bookingId' },
      { headerName: 'CUSTOMER', field: 'userName' },
      { headerName: 'DATE', field: 'bookingDateTime', sortable: true, comparator: this.dateComparator, sort: 'asc', cellRenderer: this.customDateRenderer.bind(this) },
      { headerName: 'AMOUNT', field: 'netAmount', valueFormatter: (p) => (p.value == null ? '' : Number(p.value).toFixed(2)) },
    ];

    this.mobileColumnDefsRoleId3 = [
      { headerName: 'BOOKING ID', field: 'bookingId', width: 120, minWidth: 120, suppressSizeToFit: true },
      { headerName: 'DATE', field: 'bookingDateTime', width: 135, minWidth: 135, suppressSizeToFit: true, sortable: true, comparator: this.dateComparator, sort: 'asc', cellRenderer: this.customDateRenderer.bind(this) },
      { headerName: 'BOOKING', field: 'bookingStatus', width: 155, minWidth: 155, suppressSizeToFit: true, cellRenderer: (params)=> {
        const config = params.data.config;
        const isCash = (params.data.paymentType || '').toLowerCase() === 'cash';
        if (config && config.trim()) {
          const durationMinutes = JSON.parse(config).expiryDuration;
          // Cash "waiting for payment" has no online payment link; only the send-link flow does.
          if (params.value === "WaitingForPayment" && durationMinutes !== 0 && !isCash) {
            return this.createPaymentLink(params.data.bookingId, params.value);
          }
        }
        return `${params.value}`;
      }},
      { headerName: 'AMOUNT', field: 'netAmount', width: 105, minWidth: 105, suppressSizeToFit: true, valueFormatter: (p) => (p.value == null ? '' : Number(p.value).toFixed(2)) },
      { headerName: 'PAYMENT', field: 'paymentStatus', width: 120, minWidth: 120, suppressSizeToFit: true },
      { headerName: 'PHONE', field: 'userPhone', width: 120, minWidth: 120, suppressSizeToFit: true },
    ];


    [this.columnDefs, this.columnDefsRoleId3, this.mobileColumnDefsRoleId3].forEach(columns => {
      columns.forEach(column => {
        if (column.field === 'paymentStatus') {
          column.valueFormatter = params => this.formatPaymentStatus(params.value);
        }
        if (column.field === 'bookingStatus' || column.field === 'paymentStatus') {
          column.cellStyle = params => ({ color: this.getStatusColor(params.value), fontWeight: '400', fontFamily: 'Nunito-R, sans-serif' });
        }
      });
      const bookingIndex = columns.findIndex(column => column.field === 'bookingStatus');
      const bookingColumn = columns.splice(bookingIndex, 1)[0];
      columns.splice(columns.findIndex(column => column.field === 'userPhone'), 0, bookingColumn);
    });

    this.externalUserContext = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT);
    this.currentUserContext = this.authService.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
    //console.log('Transactions Page Current User', this.currentUserContext);
    //console.log('Transactions Page Ext User', this.externalUserContext);


    this.tenantId = JSON.parse(this.currentUserContext || this.externalUserContext || '{}').tenantId;
    //console.log("Transactions Tenant Id 2", AppConstants.SESSION_STORAGE_TENANTID);



    if (this.externalUserContext) {
      this.roleId = Number(JSON.parse(this.externalUserContext).roleId);
    } else if (this.currentUserContext) {
      this.roleId = Number(JSON.parse(this.currentUserContext).roleId);
    } else {
      this.roleId = 0; // user not logged in
    }

    if (this.roleId == 1) {
      this.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
    }

    // if (this.roleId < 4 && this.roleId > 0) {
    //   this.getAllTransactions(); // Only for Superadmin and admin  Need to add condition
    // }

    this.updateColumnDefs();

  }

  formatPaymentStatus(value: unknown): string {
    const status = String(value ?? '');
    return status.charAt(0).toUpperCase() + status.slice(1);
  }

  updateDisplayedColumns() {
      if (this.isMobile) {
        this.displayedColumns = ['bookingId','customer', 'date', 'payment', 'amount'];
      } else {
        this.displayedColumns = [
          'bookingId',
          'customer',
          'date',
          'amount',
          'payment',
          'booking',
          'phone',
          'endDate'
        ];
      }
    }

  ngAfterViewInit() {
    this.getData();
    this.layoutObserver = new ResizeObserver(this.scheduleTableLayout);
    this.layoutObserver.observe(this.transactionPage.nativeElement);
    window.visualViewport?.addEventListener('resize', this.scheduleTableLayout);
    this.scheduleTableLayout();
  }

  getData(){
    if(this.roleId == 3) {
      this.getAllTransactions();
    } else {
      this.getPaginatedData();
    }
  }
  getPaginatedData() {

    this.pageSubscription?.unsubscribe();
    this.pageSubscription = merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;

          return this.getTransaction(
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          ).pipe(
            catchError(() => observableOf(null))
          );
        }),
        map((empData) => {

          if (empData == null) {
            this.isLoading = false;
            return [];
          }

          this.resultsLength = empData[1];
          this.isLoading = false;

          // ✅ Transform response
          return empData[0].map(row => {

            let endDate = '';

            if (row.slotsBooked) {

              // Skip addOn rows: the end date belongs to the booked slots.
              const slotGroups = (Object.values(row.slotsBooked) as any[][]).filter(group => !group?.[0]?.isAddOn);

              const firstGroup = slotGroups[0] as any[] | undefined;
              const firstSlot = firstGroup?.[0];

              if (firstSlot?.endDate) {
                endDate = firstSlot.endDate;
              } /* else if (firstSlot?.date) {
                endDate = firstSlot.date;
              } */
            }

            return {
              ...row,
              endDate: endDate,
              netAmount: this.computeNetAmount(row)
            };
          });

        })
      )
      .subscribe((empData) => {
        this.data = empData;
      });
  }
  /* getPaginatedData() {

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
      startWith({}),
      switchMap(() => {
        this.isLoading = true;
        return this.getTransaction(
          this.paginator.pageIndex,
          this.paginator.pageSize,
          this.sort.active,
          this.sort.direction
        ).pipe(catchError(() => observableOf(null)));
      }),
      map((empData) => {
        if (empData == null) return [];
        this.resultsLength = empData[1];
        this.isLoading = false;
        return empData[0];
      })
    ).subscribe((empData) => {
      this.data = empData;
    });
  } */

  // Net payable = subtotal + platform fee - order-level discount (if any)
  computeNetAmount(row: any): number {
    const subtotal = Number(row?.totalAmount) || 0;
    const fee = Number(row?.totalPlatformFeeEndUser) || 0;
    const discount = Number(row?.discountAmount) || 0;
    return Math.round((subtotal + fee - discount) * 100) / 100;
  }

  // Custom date renderer function
  customDateRenderer(params) {

    const formattedDate = this.datePipe.transform(params.value, 'dd MMM yy h:mm');
    //console.log("customDateRenderer : ", formattedDate);
    return formattedDate;
  }
  checkIfMobile() {
      this.isMobile = window.innerWidth < 600; // Bootstrap breakpoint for mobile
    }
  updateColumnDefs() {
    const isMobile = window.innerWidth < 600; // Adjust the breakpoint as needed

    if (isMobile) {
      //console.log("RoleId: ", this.roleId);
      if (this.roleId == 3) {
        this.gridOptions.columnDefs = this.mobileColumnDefsRoleId3;
      }
      else {
        this.gridOptions.columnDefs = this.mobileColumnDefs;
      }
    } else {

      if (this.roleId == 3) {
        this.gridOptions.columnDefs = this.columnDefsRoleId3;
      }
      else {
        this.gridOptions.columnDefs = this.columnDefs;
      }

    }

  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.checkIfMobile();
    this.updateColumnDefs();
    this.scheduleTableLayout();
  }

  dateComparator(date1: string, date2: string): number {
    const date1Value = new Date(date1);
    const date2Value = new Date(date2);

    //console.log ("date 1:", date1Value );
    //console.log ("date 2:", date2Value );
    if (date1Value < date2Value) {
      return 1;
    } else if (date1Value > date2Value) {
      return -1;
    } else {
      return 0;
    }
  }


  onEndDateChange(Date) {
    console.log("End Date", Date);
    this.toDate = Date;
    if(this.paginator){
      this.paginator.pageIndex = 0;
    }
    this.search();
  }
  onStartDateChange(Date) {
    console.log("Start Date", Date);
    this.startDate = Date;
    if(this.paginator){
      this.paginator.pageIndex = 0;
    }
    this.search();
  }

  getAllTransactions() {
    this.isLoading = true;
    console.log("Transactions : GetAllTransactions ");
    var date = new Date();
    //this.startDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    //this.toDate == this.datePipe.transform(date, 'yyyy-MM-dd');
    //this.toDate = this.startDate;
    console.log("Transactions Tenant Id: ", this.tenantId); console.log("Transactions ROle Id: ", this.roleId);
    this.transactionsSubscription?.unsubscribe();
    this.transactionsSubscription = this.authService.getAllTransactions(this.tenantId, this.startDate, this.toDate, this.roleId).subscribe(
      (response: any[]) => {
        this.allUserTransactions = (response || []).map(row => ({
          ...row,
          netAmount: this.computeNetAmount(row)
        }));
        this.applyUserFilters();
        this.isLoading = false;
        this.showPendingPayments();
        console.log(" Transactions Data : ", this.rowData);
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }


  getTransaction(pageIndex, pageSize, sortColumn, sortDirection) {
    console.log("Transactions : GetAllTransactions ");
    var date = new Date();
    //this.startDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    //this.toDate == this.datePipe.transform(date, 'yyyy-MM-dd');
    //this.toDate = this.startDate;
    //console.log("Transactions Tenant Id: ", this.tenantId); console.log("Transactions ROle Id: ", this.roleId);
    return this.authService.getTransactionsInPagination(this.tenantId, this.startDate, this.toDate, this.roleId, pageIndex, pageSize, sortColumn, sortDirection, this.searchText);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (window.innerWidth >= 600) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  /* onHeaderClicked(event: any) {
      const isHeaderClicked = event.colDef != null;

      if (isHeaderClicked) {
        // Clicked on a header cell
        console.log('Header clicked:', event.colDef.headerName);
      }
  } */
  selectedDays = [];
    productEditAddSessionChips: string[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
  ];
  onRowClicked(event: any) {

    //console.log("row id", event);

    if (!event) {
      return;
    }

    let bookingData;

    if (this.roleId == 3) {
      bookingData = event.data;
    } else {
      bookingData = event;
    }

    //console.log("bookingData : ", bookingData);

    // ✅ Basic Details
    this.bookingInfo = bookingData;
    this.userName = bookingData.userName;
    this.bookingId = bookingData.bookingId;
    this.userEmail = bookingData.userEmail;
    this.userPhone = bookingData.userPhone;

    this.bookingDateTime = this.getFormattedDateWithTime(bookingData.bookingDateTime);
    this.bookingStatus = bookingData.bookingStatus;
    this.totalAmount = bookingData.totalAmount;
    this.discountType = bookingData.discountType;
    this.discountAmount = bookingData.discountAmount;
    this.totalPlatformFeeEndUser = bookingData.totalPlatformFeeEndUser;
    this.netAmount = this.computeNetAmount(bookingData);
    this.paymentType = bookingData.paymentType;
    this.paymentStatus = bookingData.paymentStatus;
    this.transactionId = bookingData.transactionId;
    this.paytmTransactionStatus = bookingData.transactionStatus;
    this.notes = bookingData.notes;
    this.bookedBy = bookingData.bookedBy;

    // AddOn rows (isAddOn) come in slotsBooked too; list them in their own section.
    const slots = {};
    this.addOnsBooked = [];
    Object.entries(bookingData.slotsBooked || {}).forEach(([uniqueId, group]: [string, any[]]) => {
      if (group && group.length > 0 && group[0].isAddOn) {
        this.addOnsBooked.push(...group);
      } else {
        slots[uniqueId] = group;
      }
    });
    this.slotsBooked = slots as any;
    this.addOnsTotal = Math.round(this.addOnsBooked.reduce((sum, a) => sum + (Number(a.amount) || 0), 0) * 100) / 100;
    this.selectedDays = bookingData.selectedDays;

    // ✅ 🔥 Extract END DATE (ONLY if present)
    this.endDate = '';

    if (bookingData.slotsBooked) {

      const slotGroups = Object.values(this.slotsBooked) as any[][];

      for (const group of slotGroups) {

        if (group && group.length > 0) {

          for (const slot of group) {

            if (slot?.endDate) {
              this.endDate = this.datePipe.transform(slot.endDate, 'dd MMM yyyy');
              break;
            }

          }

          if (this.endDate) break; // stop outer loop
        }
      }
    }

    console.log("Extracted End Date:", this.endDate);

    // ✅ Show modal
    this.openBookingDetailsModal();
  }
  /* onRowClicked(event: any) {

    console.log("row id", event);

    if (!event) {
      return;
    }

    let bookingData;

    if (this.roleId == 3) {
      bookingData = event.data;
    } else {
      bookingData = event;
    }

    console.log("bookingData : ", bookingData);

    // ✅ Basic details
    this.userName = bookingData.userName;
    this.bookingId = bookingData.bookingId;
    this.userEmail = bookingData.userEmail;
    this.userPhone = bookingData.userPhone;

    this.bookingDateTime = this.getFormattedDateWithTime(bookingData.bookingDateTime);
    this.bookingStatus = bookingData.bookingStatus;
    this.totalAmount = bookingData.totalAmount;
    this.paymentType = bookingData.paymentType;
    this.paymentStatus = bookingData.paymentStatus;
    this.transactionId = bookingData.transactionId;
    this.paytmTransactionStatus = bookingData.transactionStatus;
    this.notes = bookingData.notes;
    this.bookedBy = bookingData.bookedBy;

    this.slotsBooked = bookingData.slotsBooked;
    this.selectedDays = bookingData.selectedDays;

    // ✅ 🔥 Extract END DATE (Fix for your issue)
    this.endDate = '';

    if (bookingData.slotsBooked) {

      const slotGroups = Object.values(bookingData.slotsBooked);

      const firstGroup = slotGroups[0] as any[] | undefined;
      const firstSlot = firstGroup?.[0];

      if (firstSlot?.endDate) {
        this.endDate = this.datePipe.transform(firstSlot.endDate, 'dd MMM yyyy');
      } else if (firstSlot?.date) {
        this.endDate = this.datePipe.transform(firstSlot.date, 'dd MMM yyyy');
      }
    }

    console.log("Extracted End Date:", this.endDate);

    // ✅ Show modal
    $("#myModal").modal("show");
  } */
 /*  onRowClicked(event: any) {

    console.log("row id", event);

    if (event == null) {
      return;
    } else {
      console.log("Transaction");
      let bookingData;
      if(this.roleId == 3) {
        bookingData = event.data;
      } else {
        bookingData = event;
      }
      this.userName = bookingData.userName;
      console.log("bookingData : ", bookingData);
      console.log("User Name: ", this.userName);

      this.bookingInfo = bookingData;
      this.bookingId = bookingData.bookingId;
      this.userEmail = bookingData.userEmail;
      this.userPhone = bookingData.userPhone;
      console.log("bookingDateTime: ", bookingData.bookingDateTime);
      this.bookingDateTime = this.getFormattedDateWithTime(bookingData.bookingDateTime);
      this.bookingStatus = bookingData.bookingStatus;
      this.totalAmount = bookingData.totalAmount;
      this.paymentType = bookingData.paymentType;
      this.paymentStatus = bookingData.paymentStatus;
      this.transactionId = bookingData.transactionId;
      this.paytmTransactionStatus = bookingData.transactionStatus;
      this.notes = bookingData.notes;
      this.bookedBy = bookingData.bookedBy;
      this.slotsBooked = bookingData.slotsBooked;
      this.selectedDays = bookingData.selectedDays;
      console.log("Slots Booked : ", this.slotsBooked);
      $("#myModal").modal("show");
    }
  } */
  search() {
    this.dateRangeError = this.startDate && this.toDate && this.startDate > this.toDate
      ? 'End date must be on or after start date.' : '';
    if (this.dateRangeError) return;
    if(this.roleId == 3) {
      this.applyUserFilters();
    } else {
      this.paginator.pageIndex = 0;
      this.getData();
    }
  }

  private showPendingPayments(): void {
    if (this.roleId !== 3 || this.pendingPaymentsChecked || this.destroyed) return;
    this.pendingPaymentsChecked = true;
    const items = pendingPaymentItems(this.allUserTransactions);
    if (!items.length) return;
    this.pendingDialog = this.dialog.open(PendingPaymentsComponent, {
      data: items, width: '640px', maxWidth: 'calc(100vw - 24px)', maxHeight: '90vh',
      autoFocus: 'first-tabbable', restoreFocus: false, ariaLabel: 'Waiting for payment'
    });
    this.pendingDialog.afterClosed().subscribe(item => {
      if (!item || this.destroyed) return;
      if (item.canPay) {
        this.router.navigate(['/payment-link'], { queryParams: { bookingId: item.row.bookingId } });
      } else {
        this.onRowClicked({ data: item.row });
      }
    });
  }

  private applyUserFilters(): void {
    const query = String(this.searchText || '').trim().toLowerCase();
    this.rowData = this.allUserTransactions.filter(row => {
      const date = row.bookingDateTime ? this.datePipe.transform(row.bookingDateTime, 'yyyy-MM-dd') : '';
      return (!this.startDate || (date && date >= this.startDate))
        && (!this.toDate || (date && date <= this.toDate))
        && String(row.bookingId || '').toLowerCase().includes(query);
    });
  }
  showModal(): void {
    this.openBookingDetailsModal();
  }

  hideModal(): void {
    // document.getElementById('close-modal').click();
    this.forceCloseBookingDetailsModal();
  }
  closeModal(): void {
    // document.getElementById('close-modal').click();
    this.forceCloseBookingDetailsModal();
  }

  private openBookingDetailsModal(): void {
    this.utilService.clearBillDeskUiState();
    this.utilService.clearBootstrapModalState();

    const modal = $(this.bookingDetailsModal.nativeElement);
    if (modal.parent()[0] !== document.body) {
      modal.appendTo(document.body);
    }

    modal.modal('show');
  }

  private forceCloseBookingDetailsModal(): void {
    const modal = $(this.bookingDetailsModal.nativeElement);
    modal.modal('hide');
    const modalElement = modal[0] as HTMLElement;

    if (modalElement) {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.removeAttribute('aria-modal');
    }

    this.utilService.clearBootstrapModalState();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.transactionsSubscription?.unsubscribe();
    this.pendingDialog?.close();
    this.pageSubscription?.unsubscribe();
    this.layoutObserver?.disconnect();
    cancelAnimationFrame(this.layoutFrame);
    window.visualViewport?.removeEventListener('resize', this.scheduleTableLayout);
    const modalElement = this.bookingDetailsModal?.nativeElement;
    if (!modalElement) {
      return;
    }
    // The modal is moved outside Angular's host, so it needs explicit teardown.
    modalElement.classList.remove('fade');
    this.forceCloseBookingDetailsModal();
    $(modalElement).modal('dispose');
    modalElement.remove();
  }

  convertTo12HourFormat(time24: string): string {
    // Split the time string into hours and minutes
    const [hours, minutes] = time24.split(':').map(Number);

    // Check if hours are greater than 12
    if (hours > 12) {
      // Convert hours to 12-hour format
      const hours12 = hours - 12;
      return `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} PM`;
    } else if (hours === 0) {
      // Midnight (00:00) is 12:00 AM in 12-hour format
      return `12:${minutes.toString().padStart(2, '0')} AM`;
    } else if (hours === 12) {
      // Noon (12:00) is 12:00 PM in 12-hour format
      return `12:${minutes.toString().padStart(2, '0')} PM`;
    } else {
      // Hours are already in 12-hour format
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} AM`;
    }
  }
  getFormattedDate(dateStr) {
    const splitDateStr = dateStr.split('T');
    const dateValue = splitDateStr[0];
    const splitDateValue = dateValue.split('-');
    return splitDateValue[2] + ' ' + this.months[parseInt(splitDateValue[1], 10) - 1] + ' ' + splitDateValue[0];
  }

  getFormattedDateWithTime(dateAndTime) {

   return this.datePipe.transform(dateAndTime, 'dd-MMM hh:mm a');

    /* const splitDateStr = dateStr.split('T');
    const dateValue = splitDateStr[0];
    const splitDateValue = dateValue.split('-');
    return splitDateValue[2] + ' ' + this.months[parseInt(splitDateValue[1], 10) - 1] + ' ' + splitDateValue[0] + ' ' + this.convertTo12HourFormat(splitDateStr[1]);
    */
 }

  isAdminRole(): boolean {
    const roleId = Number(this.roleId);
    return roleId === 1 || roleId === 2;
  }

  private createPaymentLink(bookingId: string, label: string): HTMLAnchorElement {
    const link = document.createElement('a');
    link.href = '/payment-link?bookingId=' + encodeURIComponent(bookingId);
    link.textContent = label;
    link.style.color = 'inherit';
    link.style.textDecoration = 'underline';
    let checking = false;
    link.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (checking) {
        return;
      }
      checking = true;
      this.authService.getBookingByConfirmationId(bookingId).subscribe(
        (bookings: any) => {
          checking = false;
          const status = this.normalizeStatus(Array.isArray(bookings) ? bookings[0]?.bookingStatus : null);
          if (status === 'cancelled' || status === 'canceled') {
            alert('This booking has been cancelled by the admin.');
          } else if (status === 'waitingforpayment') {
            this.router.navigate(['/payment-link'], { queryParams: { bookingId } });
          } else {
            alert('This booking is no longer available for payment.');
          }
        },
        () => {
          checking = false;
          alert('Unable to check the booking status. Please try again.');
        }
      );
    });
    return link;
  }

  canCancelBooking(): boolean {
    const status = this.normalizeStatus(this.bookingStatus);
    return (
      this.isAdminRole()
      && (status === 'booked' || status === 'waitingforpayment')
    );
  }

  canDeleteSlot(slot: any): boolean {
    const status = this.normalizeStatus(slot?.status || slot?.bookingStatus || this.bookingStatus);
    return (
      this.isAdminRole()
      && this.normalizeStatus(this.bookingStatus) !== 'waitingforpayment'
      && (status === 'booked' || status === 'waitingforpayment')
    );
  }

  normalizeStatus(status: any): string {
    return String(status || '').toLowerCase().replace(/\s+/g, '');
  }

  getStatusColor(status: any): string {
    switch (this.normalizeStatus(status)) {
      case 'paid':
      case 'booked':
      case 'success':
      case 'successful':
      case 'completed':
        return 'green';
      case 'failed':
      case 'cancelled':
      case 'canceled':
      case 'expired':
        return 'red';
      case 'waitingforpayment':
      case 'pending':
      case 'unpaid':
      case 'notpaid':
      case 'initiated':
      case 'processing':
        return 'orange';
      default:
        return 'inherit';
    }
  }

  // Only a cash booking that is waiting for payment can be marked as paid, and only by an admin
  // (roleId 1 = super admin, 2 = tenant admin). End users (roleId 3) must never see this.
  canMarkAsPaid(): boolean {
    return (
      this.isAdminRole()
      && this.bookingStatus === 'WaitingForPayment'
      && (this.paymentType || '').toLowerCase() === 'cash'
    );
  }

  markAsPaid(): void {
    this.hideModal();
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { message: 'Confirm that the cash payment has been collected. This will mark the booking as Paid.' },
      panelClass: 'confirmation-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.authService.markBookingAsPaid(this.bookingId).subscribe(
          (response: any) => {
            console.log("Booking marked as paid: ", this.bookingId);
            this.getData();
          },
          (error) => {
            console.log('markAsPaid failed: ' + JSON.stringify(error));
            alert('Unable to mark the booking as paid. Please try again.');
          }
        );
      }
    });
  }

  cancelBooking(): void {

    console.log("Cancel Booking confirmation");

    this.hideModal();
    // Open a confirmation dialog
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { message: 'This action will cancel all the slots in this booking. Are you sure you want to cancel this booking?' },
      panelClass: 'confirmation-dialog-container'

    });
    // Handle dialog closing
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // User confirmed, cancel the booking
        this.cancelBookingResponse = this.authService.cancelBooking(this.bookingId).subscribe(
          (response: any) => {
            console.log("Booking Cancelled : ", this.bookingId);
            this.getData();
          },
          (error) => {
            console.log('cancelBooking' + JSON.stringify(error));
          }
        );
      } else {
        // User cancelled, do nothing or handle accordingly
      }
    });
  }

  cancelSlot(index): void {
    this.showConfirmationIndex = this.showConfirmationIndex === index ? null : index;
  }

  getDateStrFromTime(timeValue) {
    const date = new Date(timeValue);
    return date.getFullYear() + '-' + this.addZeroIfRequired(date.getMonth() + 1) + '-' +
      this.addZeroIfRequired(date.getDate());
  }

  addZeroIfRequired(value: number) {
    if (value > 9) {
      return value;
    }
    return '0' + value;
  }

  confirmAction(info): void {
    this.showConfirmationIndex = null;
    const slotId = info.slotId || info.uniqueId || (
      (info.tenantId || this.bookingInfo.tenantId) + '_' +
      (info.productId || this.bookingInfo.productId) + '_' +
      this.getDateStrFromTime(info.date) + '_' +
      info.startTime + '_' +
      info.endTime + '_' +
      (info.venueId || this.bookingInfo.venueId)
    );
    this.authService.cancelSlots([slotId], this.bookingId).subscribe(
      (response: any) => {
        console.log("Booking Cancelled for the Booking ID: ", slotId);
        info.status = "Cancelled";
        if (this.roleId < 4 && this.roleId > 0) {
          //this.getAllTransactions(); // Only for Superadmin and admin  Need to add condition
          this.getData();
        }
      },
      (error) => {
        console.log('Cancellation Failed :' + JSON.stringify(error));
      }
    )
  }

  cancelAction(): void {
    this.showConfirmationIndex = null;
  }

  /* cancelBooking()
    {

      this.cancelBookingResponse = this.authService.cancelBooking(this.bookingId).subscribe(
        (response: any) => {
          console.log("Booking Cancelled : ", this.bookingId);
        },
        (error) => {
          console.log('cancelBooking' + JSON.stringify(error));
        }
      )
    } */
}
